/* mobile nav drawer - open/close state sync */

(function () {
  'use strict';

  var SUMMARY = '.header__drawer--mobile summary.header__icon--menu';
  var DETAILS = 'details.menu-drawer-container';
  var MOBILE = '.header__drawer--mobile ' + DETAILS;

  /* The panel only slides while the <details> still carries `open`: once that
     goes, the content sits in a content-visibility:hidden subtree and no
     transition is created. A summary click strips it as its native default
     action, in the same task as the handler. Suppressing the native toggle
     hands teardown back to the component, which removes the attribute itself
     once the transition has finished. Opening is left alone. */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var summary = target.closest(SUMMARY);
      if (!summary) return;

      var details = summary.closest(DETAILS);
      if (details && details.hasAttribute('open')) event.preventDefault();
    },
    true
  );

  /* dialog.js sets and clears html[scroll-lock] off the toggle event of any
     [scroll-lock] element with no reference count, so a toggle fired before it
     loads is lost - leaving the page locked behind a closed drawer, or unlocked
     behind an open one. Hence deriving the flag from what is actually open. */
  function lockOwnerOpen() {
    var owners = document.querySelectorAll('[scroll-lock]');

    for (var i = 0; i < owners.length; i++) {
      if (owners[i] !== document.documentElement && owners[i].open) return true;
    }

    return false;
  }

  function syncScrollLock() {
    var root = document.documentElement;
    var locked = root.hasAttribute('scroll-lock');
    var wanted = lockOwnerOpen();

    if (wanted === locked) return;
    if (wanted) root.setAttribute('scroll-lock', '');
    else root.removeAttribute('scroll-lock');
  }

  /* A <summary> is live as soon as it is parsed, but the panel only moves once
     header-drawer.js has defined <header-drawer>. A tap in that window natively
     sets `open` and nothing else, leaving the drawer half-open unrecoverably.
     So finish it once the component is ready and re-fire toggle by hand, since
     the real one went out before its listeners existed. Re-setting `open`
     instead would not work: <details> coalesces toggle and can fire nothing. */
  function reconcile(details) {
    if (!details.hasAttribute('open')) return;
    if (details.classList.contains('menu-open')) return;

    var host = details.closest('header-drawer');
    if (!host || typeof host.open !== 'function') return;

    host.open();
    details.dispatchEvent(new Event('toggle'));
  }

  function reconcileAll() {
    var drawers = document.querySelectorAll(MOBILE);

    for (var i = 0; i < drawers.length; i++) reconcile(drawers[i]);

    syncScrollLock();
  }

  /* whenDefined resolves a microtask after customElements.define, and elements
     already in the document are upgraded synchronously inside that call. Not
     behind requestAnimationFrame: a page loading in a background tab never gets
     that frame. */
  function init() {
    reconcileAll();
  }

  if (window.customElements) {
    customElements.whenDefined('header-drawer').then(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  /* Every [scroll-lock] element, not just this drawer: dialog.js clears the flag
     whenever any of them reports closed, so the cart or search dialog settling
     into its closed state ~1.3s after load wipes a lock the open menu drawer
     still needs. Twice on purpose - the deferred pass runs after dialog.js,
     which registers its capture listener later than this file. */
  document.addEventListener(
    'toggle',
    function (event) {
      var el = event.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('scroll-lock')) return;

      syncScrollLock();
      setTimeout(syncScrollLock, 0);
    },
    true
  );

  /* The Essential Cart Drawer app runs closeDrawers() twice while it boots
     (~3.8s and ~4.0s after load) and each pass strips html[scroll-lock] - the
     theme's attribute, not one of its own - without checking whether anything
     still needs it. Nothing routes it through a toggle event, so watching the
     attribute itself is the only way to hold the line. */
  if (window.MutationObserver) {
    new MutationObserver(syncScrollLock).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scroll-lock'],
    });
  }
})();
